import { Doc } from './document';

export const RESUME_COVER: Doc[] = [
    { name: 'Resume', url: '../../../assets/docs/resume-cover/resume.jpg', visibility: true},
    { name: 'Cover Letter', url: '../../../assets/docs/resume-cover/cover_letter.jpg', visibility: true}
];


export const PROFESSIONAL: Doc[] = [
    {name: 'Open House volunteer', url: '../../../assets/docs/professional-docs/open-house-volunteer.jpg', visibility: true},
    {name: 'Reference from RBC', url: '../../../assets/docs/professional-docs/reference_rbc.jpg', visibility: true},
    {name: 'Appreciation letter from Division of Student Success',
        url: '../../../assets/docs/professional-docs/student_success_appreciation.jpg', visibility: true},
    {name: 'Conference Certificate with Student Assosiation', visibility: true,
        url: '../../../assets/docs/professional-docs/student-success-conference-thanks.jpg'},
    {name: 'Appreciation letter from the TLC', url: '../../../assets/docs/professional-docs/tlc_appreciation.jpg', visibility: true},
    {name: 'Recognition letter from TLC', url: '../../../assets/docs/professional-docs/tlc_recognition.jpg', visibility: true}
];
